import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LaunchIcon from "@material-ui/icons/Launch";

const useStyles = makeStyles({
    link: {
        textDecoration: "none",
    },
    icon: {
        width: "0.5em",
        paddingLeft: 2,
    },
});

export const NewTabUrlField = ({ url }) => {
    const classes = useStyles();
    return (
        <a
            href={url}
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
        >
            Click To Open In New Tab
            <LaunchIcon className={classes.icon} />
        </a>
    );
};

export default NewTabUrlField;
